import { TableHeaderCustomer } from './types';

export const tableHeadCustomerData: TableHeaderCustomer[] = [
  { title: 'Nome', flex: 2 },
  { title: 'CPF/CNPJ' },
  { title: 'Conta' },
  { title: 'Suitability' },
  { title: 'Cadastro' },
  { title: 'Saldo disponível' },
  { title: '' },
];
